import styled from "styled-components";

const Link = styled.a`
    color: #FFF;
    font-weight: 500;
    font-size: 1em;
`

export default Link;